import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContestsService, SEOService } from '@box-core/services';
import { Contest, SeoOptions } from '@box-types';
import { deleteJsonLd } from '@box/utils';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'account-contests',
  templateUrl: './account-contests.page.html',
  styleUrls: ['./account-contests.page.scss']
})
export class AccountContestsPage implements OnInit, OnDestroy {
  public wonContests: Contest[] = [];
  public loading = true;
  private contestSubscription: Subscription;

  constructor(
    private contestsService: ContestsService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setContestSubscription();
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    if (!this.contestSubscription) this.contestSubscription.unsubscribe();
    deleteJsonLd();
  }

  private setContestSubscription(): void {
    this.loading = true;
    this.contestSubscription = this.contestsService
      .getWonContests()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((contests) => {
        this.wonContests = contests;
      });
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
